import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { MealItemEntity } from '../../domain/entities/MealItemEntity'
import type { MealItemAdminDto } from '@/backend/market'

export class MealItemModel extends MealItemEntity {
  constructor(dataDto: MealItemAdminDto) {
    super()
    mapEntityProperties<MealItemEntity>(this, dataDto, {
      map: {
        user: dataDto.mealUserCompanyUserUser
      }
    })
  }
}
